import { type ProjectCode, type CountryCode } from '@constants'
import { type Transaction } from '@hooks-api/types/dataModel/fpOrder'
import { type ECommerceProduct } from '@hooks-api/types/dataModel/products'
import { createContext, useContext, useMemo, type PropsWithChildren } from 'react'

type OrderDetailContextProps = OrderDetailProviderProps

export const OrderDetailContext = createContext<OrderDetailContextProps | null>(null)

export interface OrderDetailProviderProps {
  transaction?: Transaction
  currency?: string
  onPayment?: () => void
  onCancel?: () => void
  onRepeatOrder?: () => void
  onDownloadOrderPdf?: () => void
  onDownloadInvoicePdf?: () => void
  showPdf?: boolean
  showMerchantInfo?: boolean
  showRecipientInfo?: boolean
  countryCode?: CountryCode
  isWarehouseOrSubscription?: boolean
  hasAddonV2?: boolean
  projectCode?: ProjectCode
  products?: ECommerceProduct[]
  environment?: 'wordPress' | 'merchant' | 'campaign'
  /** 2B 通路訂單明細優先顯示 2B 商品圖。分階段上線閘門：TODO: 全部 2B 站上線後等價於 environment === 'merchant'，屆時可移除 */
  b2bProductImageFirst?: boolean
}

export const OrderDetailProvider = (props: PropsWithChildren<OrderDetailProviderProps>) => {
  const { children, ...rest } = props

  const contextValue = useMemo(() => rest, [rest])

  return (
    <OrderDetailContext.Provider value={contextValue}>
      {children}
    </OrderDetailContext.Provider>
  )
}

export const useContextOrderDetail = () => {
  const context = useContext(OrderDetailContext)
  if (!context) {
    throw new Error('useContextOrderDetailV2 has to be used within <OrderDetailProvider>')
  }
  return context
}
